import * as React from "react";

import {
    Tab,
    TabList,
    TabSize,
    TabProvider,
    IVssContributedTab,
    TabContent,
    TabGroupProvider
} from "azure-devops-ui/Tabs";
import { ObservableValue, ObservableArray } from "azure-devops-ui/Core/Observable";
import { ITabGroup } from "azure-devops-ui/Components/Tabs/Tabs.Props";

export default class SimpleTabListExample extends React.Component {
    private selectedTabId: ObservableValue<string>;

    constructor(props: {}) {
        super(props);
        this.selectedTabId = new ObservableValue("Overview");
        this.state = {
            isLarge: false
        };
    }

    public render() {
        return (
            <div>
                <div className="flex-row flex-grow" style={{ height: 1200 }}>
                    <TabGroupProvider providers={groupProviders}>
                        <TabProvider providers={providers} selectedTabId={this.selectedTabId}>
                            <TabList
                                key={1}
                                onSelectedTabChanged={this.onSelectedTabChanged}
                                selectedTabId={this.selectedTabId}
                                tabSize={TabSize.Tall}
                                listTitle="Project settings"
                                tabGroups={groups}
                            >
                                {...tabs}
                            </TabList>
                            <TabContent />
                        </TabProvider>
                    </TabGroupProvider>
                </div>
            </div>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        this.selectedTabId.value = newTabId;
        this.forceUpdate();
    };
}

const groups: ITabGroup[] = [
    {
        id: "Boards",
        name: "Boards",
        order: 1
    },
    {
        id: "Repos",
        name: "Repos",
        order: 2
    },
    {
        id: "Pipelines",
        name: "Pipelines",
        order: 3
    },
    {
        id: "Test",
        name: "Test",
        order: 4
    },
    {
        id: "Examples",
        name: "Examples",
        order: 5
    }
];

const tabs = [
    makeTab("Overview"),
    makeTab("Teams"),
    makeTab("Permissions"),
    makeTab("Notifications"),
    makeTab("Service hooks"),
    makeTab("Audit log"),
    makeTab("Project configuration", "Boards"),
    makeTab("Team configuration", "Boards"),
    makeTab("Repositories", "Repos"),
    makeTab("Branches", "Repos"),
    makeTab("Agent queues", "Pipelines"),
    makeTab("Service endpoints", "Pipelines"),
    makeTab("Agent pools", "Pipelines"),
    makeTab("Deployment pools", "Pipelines"),
    makeTab("Retention", "Pipelines"),
    makeTab("Concurrent jobs", "Pipelines"),
    makeTab("Retention", "Test"),
    makeTab("Badge example", "Examples", 123456789),
    makeTab("Overflow tooltip example wow this is nifty", "Examples"),
    makeTab("Out of order example", "Repos")
];

function makeTab(name: string, groupName?: string, badgeCount?: number) {
    const id = name + (groupName || "");
    return <Tab name={name} id={id} key={id} groupId={groupName} badgeCount={badgeCount} />;
}

const providers = new ObservableArray<IVssContributedTab>();
setTimeout(() => {
    providers.push(
        {
            id: "tab3",
            name: "Provided tab",
            groupId: "Contributed",
            render: () => <div className="page-content">Contributed Tab</div>
        },
        {
            id: "tab4",
            name: "Provided with no group id",
            render: () => <div className="page-content">Contributed Tab</div>
        }
    );
}, 100);

const groupProviders = new ObservableArray<ITabGroup>();
setTimeout(() => {
    groupProviders.push({ id: "Contributed", name: "Contributed", order: 120 });
}, 100);
